package com.milta.core.localization.translations.nl

import com.milta.core.localization.WebImportRouteStrings

internal val WebImportRoute = WebImportRouteStrings(
    headerSubtitle = "Upload een leveringsbestand en wijs het toe aan een chauffeur",
    stepImport = "Importeren",
    stepVerifyAssign = "Controleren & toewijzen",
    stepValidateSend = "Bevestigen en tournees versturen",
    dropzoneTitle = "Sleep uw leveringsbestand hierheen",
    dropzoneOrPrefix = "of",
    browseFilesLink = "blader door uw bestanden",
    browseFilesButton = "Bestanden doorzoeken",
    constraintsLabel = "Excel (.xlsx, .xls), CSV of PDF · max. 500 stops · 10 MB",
    expectedColumnsEyebrow = "Verwachte kolommen in het bestand",
    columnRecipientName = "Naam ontvanger",
    columnAddress = "Volledig adres",
    columnDeadline = "Uiterste tijd",
    columnPhone = "Telefoon",
    requiredPillLabel = "Verplicht",
    optionalPillLabel = "Optioneel",
    analysingLabel = "Analyseren…",
    analysingCanLeaveLabel = "Bestand verzonden. U kunt deze pagina verlaten, de analyse gaat door.",
    importOnMobileMessage = "Er loopt een import in de mobiele app (%s). Rond deze af in de app om hier een ander bestand te importeren.",
    invalidFileTitle = "Onleesbaar bestand of niet-ondersteund formaat",
    invalidFileMessage = "'%s' kon niet worden geanalyseerd. Gebruik een Excel- (.xlsx, .xls), CSV- of PDF-bestand met de verwachte kolommen.",
    chooseAnotherFileButton = "Ander bestand kiezen",
    extractionFailedTitle = "Kan de leveringen niet extraheren",
    extractionFailedMessage = "Het bestand '%s' is gelezen, maar er is geen bruikbare rij gevonden. Controleer of het de verwachte kolommen bevat.",
    serviceUnavailableTitle = "Analysedienst tijdelijk niet beschikbaar",
    serviceUnavailableMessage = "We kunnen uw bestand momenteel niet analyseren. Uw bestand blijft bewaard: probeer het over enkele ogenblikken opnieuw.",
    retryButton = "Opnieuw proberen",
    fileImportedStatus = "Bestand geïmporteerd",
    stopsDetectedSuffix = "stops gedetecteerd",
    replaceFileLink = "↺ Vervangen",
    assignToEyebrow = "Toewijzen aan",
    selectDriverRequiredError = "Selecteer minstens één chauffeur voordat u de tournee verstuurt.",
    selectedDriversCountSuffix = "chauffeurs geselecteerd",
    optimizeRouteButton = "Route optimaliseren",
    tableCaptionLead = "Controleer en corrigeer de stops voordat u verstuurt",
    tableCaptionHint = "Klik op het potlood om een regel te corrigeren",
    locationBlockedHint = "Elke rij heeft een gelokaliseerd adres (GPS) nodig voordat ze naar de chauffeurs wordt gestuurd. Corrigeer de betreffende rijen (✎) of probeer de geocodering opnieuw.",
    columnHeaderIndex = "#",
    columnHeaderRecipientName = "Naam ontvanger",
    columnHeaderAddress = "Adres",
    columnHeaderPhone = "Telefoon",
    columnHeaderDeadline = "Uiterste tijd",
    columnHeaderPackageCount = "Pakketten",
    dashPlaceholder = "—",
    discardDraftButton = "Import annuleren",
    discardDraftDialogTitle = "Deze import annuleren?",
    discardDraftDialogMessage = "De reeds geïmporteerde leveringen gaan definitief verloren. Deze actie kan niet ongedaan worden gemaakt.",
    discardDraftConfirmButton = "Ja, import annuleren",
    freeFormatBanner = "Vrij formaat gedetecteerd — kolommen konden niet automatisch worden herkend, controleer elke regel voordat u verstuurt.",
    incompleteStopsBannerSuffix = "onvolledige stops — naam of adres ontbreekt, te corrigeren vóór verzending.",
    rowFlagMissingName = "⚠ naam ontbreekt",
    rowFlagMissingAddress = "⚠ adres ontbreekt",
    alreadyDispatchedBanner = "Deze tournee is al naar een chauffeur verstuurd — ververs de pagina om een nieuwe import te starten.",
    routeNotFoundError = "Tournee niet gevonden. Ververs de pagina en probeer opnieuw.",
    validationErrorGeneric = "Controleer de ingevoerde gegevens.",
    submitServerError = "Er is een fout opgetreden. Probeer het opnieuw.",
    submitOptimizationUnavailableError = "Optimalisatiedienst tijdelijk niet beschikbaar. De tournee werd niet aangemaakt — probeer het over enkele ogenblikken opnieuw.",
    sendWithoutOptimizationButton = "Verzenden zonder optimalisatie",
    dispatchSuccessMessage = "Tournee succesvol verzonden naar %s",
    dispatchSuccessBatchMessage = "Tournees succesvol verzonden naar %d chauffeurs",
    tooManyStopsError = "Dit bestand bevat meer dan 500 leveringen. Splits het op voordat u het importeert.",
    resultHeaderMiddle = "leveringen verdeeld over",
    resultDriverSingularSuffix = "chauffeur",
    resultDriverPluralSuffix = "chauffeurs",
    resultDistanceLabel = "Afstand",
    resultDurationLabel = "Geschatte duur",
    resultMetricNotCalculatedLabel = "Niet berekend",
    resultStopsChipSuffix = "stops",
    resultMoreStopsTemplate = "+ %d overige stops",
    resultStopsLoadError = "Kan de stops van deze tournee niet laden.",
    resultDispatchButton = "Bevestigen en tournees versturen",
)
